import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const authService = { constants, slice, sagas };

export default authService;

